import { render } from "./Markdown.vue?vue&type=template&id=56d6913e&scoped=true&ts=true"
import script from "./Markdown.vue?vue&type=script&lang=ts"
export * from "./Markdown.vue?vue&type=script&lang=ts"

import "./Markdown.vue?vue&type=style&index=0&id=56d6913e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d6913e"]])

export default __exports__